import { configureStore } from '@reduxjs/toolkit';
import reducer from './rootReducer';
var store = configureStore({
    reducer: reducer,
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    'additionalInfo/updateSelectedFile',
                    'additionalInfo/updateAcceptedFiles',
                    'additionalInfo/updateRejectedFiles'
                ],
                ignoredActionPaths: [
                    'payload.returnToParent',
                    'payload.errorCallback',
                    // Passed by channel app as URL objects, later converted into strings in the reducer.
                    'payload.hosts',
                    /*
                     * Enforced by syf-api typings, we don't really use it.
                     * TODO: Update syf-api to remove this if it's not leveraged by consumer apps.
                     */
                    'payload.apiErrorCallback',
                    'payload.navigationHandler',
                    'payload.parentSecureMessage'
                ],
                ignoredPaths: [
                    'appConfig',
                    'mfeConfig',
                    'additionalInfo.rejectedFiles',
                    'additionalInfo.acceptedFiles',
                    'additionalInfo.selectedFile'
                ]
            }
        });
    }
});
export default store;
//# sourceMappingURL=store.js.map